import { useTranslation } from 'react-i18next'
import { InsuranceProposal } from 'src/types'
import { toDate, toHour } from 'src/utils'

export const useNextSteps = ({ policy }: { policy?: InsuranceProposal }) => {
  const { t } = useTranslation()
  const fills = {
    startDate: toDate(policy?.dataInizio) || '',
    startHour: toHour(policy?.dataInizio) || '',
    endDate: toDate(policy?.dataFine) || '',
    endHour: toHour(policy?.dataFine) || '',
  }

  return {
    t,
    fills,
  }
}
